











































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFamilyStore } from "@/employee/store/family";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { OnboardingBalanceTransfer as BalanceTransferRoute, OnboardingUpfrontContribution } from "@/employee/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component
export default class FinishV2 extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();
  familyStore = useFamilyStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();

  mounted (): void {
    if (!this.familyStore.isFamilyStateLoaded) {
      this.familyStore.initialize();
    }
    else {
      this.$emit("complete");
    }
  }

  @Prop() routeToFinish;

  @Watch("familyStore.isFamilyStateLoaded")
  onStateChange (payLoad) {
    if (payLoad) {
      this.$emit("complete");
    }
  }

  get isLoaded () {
    return this.familyStore.isFamilyStateLoaded;
  }

  get contactUsUrl () {
    return this.custodianSettingsStore.contactUsUrl;
  }

  get routeToBalanceTransfer () {
    return { name: BalanceTransferRoute };
  }

  get routeToLinkedAccounts () {
    return { name: OnboardingUpfrontContribution };
  }
}
